class LxcParallax extends HTMLElement{
  constructor(){
    super();
    this.config= JSON.parse(this.getAttribute('config'));
    this.control = this.querySelector('lxc-video-controls');

    // console.log(this.config)
    if(!this.config){
      this.config = {
        parallax: true,
        scale: false
      }
    }
    this.section_id = this.config.sid
    this.video_dk = this.querySelector(`#video-${this.section_id} video`);
    this.video_mb = this.querySelector(`#video-mobile-${this.section_id} video`);
    // console.log(this.video_dk, this.video_mb)
      this.init();
    if(window.innerWidth < 750){
    }
  }
  init(){
    if(this.config.parallax){
      this.closest('section').classList.add('lxc-animate-parallax');
    }
    if(this.config.scale){
      this.classList.add('lxc-animate-scroll');
      this.animateScroll();
    }
    this.hideOnCover();
  }
  animateScroll(){
    let lastscroll = window.scrollY;
    let scale = 1;
    window.addEventListener('scroll', () => {
      let ob_pos = this.getBoundingClientRect().top;
      let  y = window.scrollY;
      if(y - lastscroll > 0){
        console.log("xuong");
        if(ob_pos <= 0){
          scale = Math.min(scale+0.001,1.5); 
        }
      }else{
        console.log("len")
        scale = Math.max(scale-0.001,1.0);
      }
      // console.log(scale,ob_pos,window.scrollY - lastscroll);
      // if(ob_pos == 0){
      //   scale = Math.min(scale+0.001,1.5);
        
      // }else{
      //   // console.log(3)
      //   scale = Math.max(scale-0.001,1.0);
        
      // }
      this.style.setProperty('--scale', scale)
      lastscroll = window.scrollY;
    })
  }
  hideOnCover(){
    let nextEl = this.closest('section').nextElementSibling;
    this.updateControlPosition(nextEl.getBoundingClientRect().top);
    window.addEventListener("scroll", ()=> {
      // console.log(this.getBoundingClientRect().top , nextEl.getBoundingClientRect().top);
      this.handleNextEl(this,nextEl);
      this.updateControlPosition(nextEl.getBoundingClientRect().top);
      

      
    })
  }
  handleNextEl(target,nextEl){
    if(parseFloat(nextEl.getBoundingClientRect().top) <= 0){
      // console.log("is-hide")
      target.style.setProperty('opacity',0);
      this.handleVideoWhenDisAppear(false,window.innerWidth);
    }else{
      // console.log("is-show")
      this.handleVideoWhenDisAppear(true,window.innerWidth);
      target.style.setProperty('opacity',1);
    }
    if(this.getBoundingClientRect().top > window.innerHeight){
      this.handleVideoWhenDisAppear(false,window.innerWidth);
    }
  }
  handleVideoWhenDisAppear(visible,breakpoint){
    if(visible){
      breakpoint > 767 ? this.video_dk?.play() : this.video_mb?.play()
    }else{
      breakpoint > 767 ? this.video_dk?.pause() : this.video_mb?.pause()
    }
  }
  updateControlPosition(nextElPos){
    if(!this.control) return;
    if(nextElPos <= 0 ){
      this.control.style.opacity = '0';
    }else{
      this.control.style.opacity = '1';
      this.control.style.setProperty('--top', `${nextElPos - 60}px`);

    }
  }
}
customElements.define('lxc-parallax', LxcParallax);


class LxcVideoControl extends HTMLElement{
  constructor(){
    super();
    this.play = this.querySelector('[data-play]');
    this.sound = this.querySelector('[data-sound]');
    this.parent = this.closest('lxc-parallax');
    this.video_dk_id = this.dataset.id;
    this.video_mb_id = this.dataset.idMb;
    this.control_id = this.video_dk_id;
    if(!this.parent) return;
    if(window.innerWidth < 767){
      this.control_id = this.video_mb_id;
    };
  // console.log(this.video_dk_id,this.video_mb_id);
    this.play.addEventListener('click', ()=> {
      this.play.classList.toggle('is-pause');
      let video = this.parent.querySelector(`#${this.control_id} video`);
      // console.log(video)
      video.paused ? video.play() : video.pause();
    });
    this.sound.addEventListener('click', () => {
      this.sound.classList.toggle('is-sound');
      let video = this.parent.querySelector(`#${this.control_id} video`);
      // console.log(video)
      video.muted ? video.muted = false : video.muted = true;
    })
  }
}
customElements.define('lxc-video-controls', LxcVideoControl);